<template>
  <router-link
    class="fl-navigation-item"
    :to="path"
    @click.native="layoutStore.closeMobileMenu"
  >
    <div class="fl-navigation-item__content">
      <ui-icon
        class="fl-navigation-item__icon"
        :name="icon"
      />
      <div class="fl-navigation-item__title">
        {{title}}
      </div>
    </div>
  </router-link>
</template>

<script>
import {UiIcon} from "@iflat/iflat-ui/src";
import {useLayoutStore} from "@/store/layout";

export default {
  components: {UiIcon},
  props: {
    title: String,
    path: [String, Object],
    icon: String,
  },
  data() {
    return {
      layoutStore: useLayoutStore()
    }
  }
}
</script>

<style lang="scss" scoped>
.fl-navigation-item {
  @include font-16;
  @include flex-space-between;
  @include transition-list([background, fill]);
  $parent: &;
  padding: 8px 12px;
  color: $gray-1;
  fill: $gray-3;
  border-radius: $border-radius-00;
  cursor: pointer;

  &:hover,
  &.router-link-active {
    background: $light-01;
  }

  &.router-link-active {
    fill: $primary;
  }

  &__content {
    display: flex;
    align-items: center;
  }

  &__title {
    margin-left: 10px;
  }

  &__notification {
    margin-left: 3px;
    flex-shrink: 0;
  }

  &__icon {
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;
    height: 24px;
    width: 24px;
  }
}
</style>
